module.exports = __webpack_public_path__ + "static/img/icon-wxpay.db0e59ef.png";